// Lead Quality Engine — configuration-driven blocked phone patterns.
// Add new fake numbers to BLOCKED_EXACT_NUMBERS or new rules to BLOCKED_REGEX_RULES.

export const BLOCKED_EXACT_NUMBERS = [
  '1234567890',
  '9876543210',
  '0123456789',
  '1212121212',
  '1010101010',
  '9090909090',
  '1231231234',
  '1122334455',
];

export const BLOCKED_REGEX_RULES = [
  /^(\d)\1+$/, // same digit repeated: 0000000000 … 9999999999
  /^(\d{2})\1{2,}$/, // two-digit cycle: 1212121212, 6767676767 …
];

export const isBlockedPattern = (digits) =>
  BLOCKED_EXACT_NUMBERS.includes(digits) || BLOCKED_REGEX_RULES.some((re) => re.test(digits));
